import { Link } from 'react-router-dom'
import { useOptionalT } from '../i18n/LocaleProvider'
import { ProgressBar } from './ProgressBar'

export interface DonationCardProps {
  image: string
  /**
   * Describes the picture. Defaults to the generic `donation Image` the placeholders have
   * always carried; pass one wherever the image is a real photograph and means something.
   */
  imageAlt?: string
  tag: string
  /** Percentage raised. */
  progress: number
  raisedLabel: string
  goalLabel: string
  title: string
  descr: string
  to: string
  ctaLabel?: string
  /** `inner` adds the `ul-donation--inner` modifier used on the donations listing. */
  variant?: 'default' | 'inner'
}

/**
 * A `.ul-donation` card with its raised/goal progress bar. Used by the Donations
 * listing and reusable for any donation grid.
 *
 * `ProgressBar` writes the counted percentage into the bar's label element.
 */
export function DonationCard({
  image,
  imageAlt = 'donation Image',
  tag,
  progress,
  raisedLabel,
  goalLabel,
  title,
  descr,
  to,
  ctaLabel: ctaLabelProp,
  variant = 'default',
}: DonationCardProps) {
  const t = useOptionalT()
  const ctaLabel = ctaLabelProp ?? t('ul.donationCard.cta')
  return (
    <div className={variant === 'inner' ? 'ul-donation ul-donation--inner' : 'ul-donation'}>
      <div className="ul-donation-img">
        <img src={image} alt={imageAlt} />
        <span className="tag">{tag}</span>
      </div>
      <div className="ul-donation-txt">
        <div className="ul-donation-progress">
          <ProgressBar
            value={progress}
            containerClassName="donation-progress-container"
            barClassName="donation-progressbar"
            labelClassName="donation-progress-label"
          />
          <div className="ul-donation-progress-labels">
            <span className="ul-donation-progress-label">{raisedLabel}</span>
            <span className="ul-donation-progress-label">{goalLabel}</span>
          </div>
        </div>
        <Link to={to} className="ul-donation-title">
          {title}
        </Link>
        <p className="ul-donation-descr">{descr}</p>
        <Link to={to} className="ul-donation-btn">
          {ctaLabel}
          <i className="flaticon-up-right-arrow" />
        </Link>
      </div>
    </div>
  )
}
